import ListUsers from '../components/ListUsers'

const UsersPage = () => (
    <ListUsers />
)

export default UsersPage
